import React, { FC } from 'react';
import { RegisterUserMutationVariables } from '../../API';
import { Button, Stack, Typography } from '@mui/material';

export const RegistrationInstructions: FC<{
  name: string;
  currentData: Partial<RegisterUserMutationVariables>;
  next: (
    updateData: Partial<RegisterUserMutationVariables>,
    done: boolean,
  ) => void;
}> = ({ next }) => {
  return (
    <Stack spacing={2}>
      <Typography variant="subtitle1">
        Registration on the MIND.set platform
      </Typography>
      <Typography variant="body2">
        MIND.set is a browser-based online platform for researchers. It
        currently offers five psychological tests to measure implicit bias and
        allows users to create, administer and collect test data. The platform
        emphasizes accessibility for the scientific community and is available
        free of charge to researchers at all levels, from students to
        professors. It includes instructions for test creation, easy integration
        with popular online survey tools, stimulus material from the DeZIM photo
        database and sample analysis scripts. <br />
        <br />
        The MIND.set platform was initiated by DeZIM.lab in 2020 as part of
        short projects for the Racism Monitor funded by the Federal Ministry for
        Family Affairs, Senior Citizens, Women and Youth (Bundesministerium für
        Familie, Senioren, Frauen und Jugend, BMFSFJ) and then became a
        long-term institutionally funded structural project of the DeZIM.lab at
        the DeZIM Institute.
        <br />
        <br />
        In the next step, we will guide you through the application form.
      </Typography>

      <Stack
        direction="row"
        sx={{ width: '100%', justifyContent: 'space-between' }}
      >
        <div />
        <Button
          onClick={() => {
            next({}, false);
          }}
        >
          Next
        </Button>
      </Stack>
    </Stack>
  );
};
